<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57.69 52l-24-41.5a2 2 0 00-3.46 0L6.31 52A2 2 0 008 55h48a2 2 0 001.73-3zM9.77 52L32 13.5 54.23 52z"/><path d="M30.5 25.5v15a1.5 1.5 0 003 0v-15a1.5 1.5 0 00-3 0zM30.59 45.09a2 2 0 000 2.82 1.88 1.88 0 00.64.44 2 2 0 00.77.15 2 2 0 001.41-.59 1.42 1.42 0 00.25-.3 1.63 1.63 0 00.19-.34 2.2 2.2 0 00.15-.77 2 2 0 00-.59-1.41 2 2 0 00-2.82 0z"/></svg>